import { NavbarDesktop } from './NavbarDesktop';
import { NavbarNotDesktop } from './NavbarNotDesktop';

export { NavbarDesktop, NavbarNotDesktop };
